import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import ServicePlans from '../components/Home/ServicePlans';
import { WrenchIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
const HomePage = () => {
  return <div data-id="element-388">
      <HeroSection data-id="element-389" />
      {/* Welcome Section */}
      <section className="py-16 bg-white" data-id="element-390">
        <div className="container mx-auto px-4" data-id="element-391">
          <div className="max-w-3xl mx-auto text-center" data-id="element-392">
            <h2 className="text-3xl font-bold text-[#0a3d62] mb-6" data-id="element-393">
              Welcome to PinnacleHub
            </h2>
            <p className="text-gray-700 mb-8 text-lg" data-id="element-394">
              We specialise in fast, professional appliance repairs and
              comprehensive service plans across the UK. Our team of experienced
              engineers is committed to providing reliable solutions for all
              your household appliance needs, ensuring minimal disruption to
              your daily life.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-395">
              <div className="flex flex-col items-center" data-id="element-396">
                <div className="bg-[#e6f7f8] p-4 rounded-full mb-4" data-id="element-397">
                  <WrenchIcon size={32} className="text-[#0a3d62]" data-id="element-398" />
                </div>
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-2" data-id="element-399">
                  Expert Engineers
                </h3>
                <p className="text-gray-600 text-center" data-id="element-400">
                  Qualified professionals with years of experience repairing all
                  major brands.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-401">
                <div className="bg-[#e6f7f8] p-4 rounded-full mb-4" data-id="element-402">
                  <ClockIcon size={32} className="text-[#0a3d62]" data-id="element-403" />
                </div>
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-2" data-id="element-404">
                  Fast Response
                </h3>
                <p className="text-gray-600 text-center" data-id="element-405">
                  Quick appointments and efficient repairs to get your
                  appliances working again.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-406">
                <div className="bg-[#e6f7f8] p-4 rounded-full mb-4" data-id="element-407">
                  <ShieldCheckIcon size={32} className="text-[#0a3d62]" data-id="element-408" />
                </div>
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-2" data-id="element-409">
                  Peace of Mind
                </h3>
                <p className="text-gray-600 text-center" data-id="element-410">
                  Fixed-price plans with no hidden costs and comprehensive
                  coverage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonial Section */}
      <section className="py-16 bg-[#f8f9fa]" data-id="element-411">
        <div className="container mx-auto px-4" data-id="element-412">
          <div className="max-w-3xl mx-auto text-center" data-id="element-413">
            <h2 className="text-3xl font-bold text-[#0a3d62] mb-12" data-id="element-414">
              What Our Customers Say
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-415">
              <div className="text-[#3fc1c9] mb-4" data-id="element-416">★★★★★</div>
              <p className="text-gray-700 text-lg italic mb-6" data-id="element-417">
                "The engineer from PinnacleHub was prompt, professional and
                fixed our washing machine in no time. The service plan has been
                excellent value for money, and the peace of mind is priceless. I
                highly recommend their services to anyone with appliance
                issues."
              </p>
              <p className="font-medium text-[#0a3d62]" data-id="element-418">
                Sarah Johnson, Glasgow
              </p>
            </div>
          </div>
        </div>
      </section>
      <ServicePlans data-id="element-419" />
    </div>;
};
export default HomePage;